import {apiSlice} from "./apiSlice";
import {Login} from "../../types/authTypes";

export const authInjectedEndpoints = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getCsrfCookie: builder.query<void, void>({
            query: () => window.env.BACKEND_URL + `/sanctum/csrf-cookie`,
            providesTags: ["CsrfCookie"]
        }),
        login: builder.mutation<Login, Login>({
            query: ({email, password}) => ({
                url: `/login`,
                method: 'POST',
                body: {email, password},
            }),
        }),
        logout: builder.mutation<[], void>({
            query: () =>  ({
                url: window.env.BACKEND_API_URL + `/logout`,
                method: 'POST',
            })
        }),
    })
});

export const authEndpoints = authInjectedEndpoints.endpoints;
export const {useGetCsrfCookieQuery, useLoginMutation, useLogoutMutation} = authInjectedEndpoints;
